// import external dependencies
import 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'popper.js/dist/popper';
import 'slick-carousel-latest/slick/slick.min';

import '../vendor/hs-megamenu/src/hs.megamenu.js';
import '../vendor/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js';
import '../vendor/dzsparallaxer/dzsparallaxer.js';
import '../vendor/cubeportfolio/js/jquery.cubeportfolio.min.js';


import Custombox from 'custombox';
window.Custombox = Custombox;
import '../vendor/custombox/dist/custombox.legacy.min.js';

import './hs.core.js';
import './components/hs.header.js';
import './components/hs.unfold.js';
import './helpers/hs.focus-state.js';
import './components/hs.malihu-scrollbar.js';
import './components/hs.modal-window.js';
import './components/hs.show-animation.js';
import './components/hs.slick-carousel.js';
import './components/hs.cubeportfolio.js';
import './components/hs.go-to.js';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js